"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=wearable-representation-definition.js.map